// extracted by mini-css-extract-plugin
export default {"accordion":"Accordion-module__accordion__S2AvB"};